import { PromptAddendumModel } from "./getLandlordResearchPrompt";
import { FindPeopleResponse } from "./postFindPeople";
import { PeopleRole, taskForRole } from "../models/peopleCandidate";
import axiosConfig from "./axiosConfig";

export interface PeopleRankingPromptTestRequest {
  // Which role's discovery to test ("landlord" | "tenant") - the people prompt is
  // per-role, so every test carries it.
  role: PeopleRole;
  // The DRAFT prompt to test - not saved. Passed as an addendum (preamble + rules)
  // and compiled by the BE via the same render used on save, so the tested prompt is
  // exactly what saving this draft would run. The BE appends the fixed answer-shape +
  // data-residency guardrail before running.
  addendum: PromptAddendumModel;
  // A real subject row to run discovery against for its chosen company/context.
  // Nothing is persisted onto it (test runs are read-only for the subject).
  subjectRef: string;
  subjectKind?: "voa" | "lead";
}

// Kick off a test people-discovery run against a draft prompt as a long-running
// operation (Apollo discovery + the ranking pass can take a while). Returns
// {status, operationKey, siteId} immediately; the FE polls useOperation(...) and
// reads the candidates + trace ref out of the operation result. Persists nothing.
const postPeopleRankingPromptTest = async (
  authToken: string,
  body: PeopleRankingPromptTestRequest
): Promise<FindPeopleResponse> => {
  const { data } = await axiosConfig.post(
    `/leads/ai-prompt/test`,
    { ...body, task: taskForRole(body.role) },
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default postPeopleRankingPromptTest;
